import { PageType } from '@tvg/product-listing-url';
import { DL_PID_Type } from 'common/types/global';
import { PLPData } from 'common/types/plp-data';
import { DataLayerPage, Tracking } from 'common/types/search-response';
import { publishAnalyticEvent } from './analytic-publish-event';

export const getParentCategoryCount = (filters: object | string | number): number => {
  if (typeof filters === 'object') {
    return Object.keys(filters).length;
  }
  return 0;
};

export const getFilterCount = (filters: object | undefined): number | string => {
  if (filters) {
    const keys = Object.keys(filters).filter((key) => !['group_id'].includes(key));
    return keys.length;
  }
  return 0;
};

export const getTotalFilterSelections = (filters: Record<string, any> | undefined): number | string => {
  if (filters) {
    const keys = Object.keys(filters).filter((key) => !['group_id'].includes(key));
    const totalCount = keys.reduce((count, key) => count + filters[key].length, 0);
    return totalCount;
  }
  return 0;
};

export const getDataLayerValues = (response: Omit<PLPData, 'rawResponse'>, pageType?: string) => {
  const {
    meta,
    meta: { request },
    products,
  } = response;

  const lineItems = products.map((product: { product_id: number; variation_id: string; catalogueNumber: string }) => ({
    product: {
      id: product?.catalogueNumber || '',
      productGroupId: product?.product_id || '',
      sku: product?.variation_id || '',
    },
  }));

  const selectedCategoryId = meta?.selected_category?.group_id || '';
  const parentCategories = meta?.parent_categories;

  const parentCategoryCount = getParentCategoryCount(parentCategories);
  let department = '';
  if (parentCategoryCount === 1) {
    department = selectedCategoryId;
  } else if (parentCategoryCount > 1 && parentCategories[1]?.group_id) {
    department = parentCategories[1].group_id;
  }
  const category = parentCategoryCount > 1 ? selectedCategoryId : '';

  /* Update sort value if browse or promo & relevance (default value) is selected */
  const sortBy =
    pageType &&
    [PageType.Browse as string, PageType.Promo as string].includes(pageType) &&
    request?.sort_by === 'relevance'
      ? 'recommended'
      : request?.sort_by || '';

  return {
    searchTerm: request?.term || '',
    numProducts: meta?.num_results || '',
    numProductsDisplayed: request?.num_results_per_page || '',
    numPagination: request?.page || '',
    sort: sortBy,
    filters: {
      numFilters: getFilterCount(request?.filters),
      numSelections: getTotalFilterSelections(request?.filters),
    },
    department,
    category,
    lineItems,
    pageType,
  } as Tracking;
};

export const isCategory = (pageType?: string) => {
  const categoryTypes = [PageType.Browse as string, PageType.Promo as string];
  return pageType && categoryTypes.includes(pageType);
};

export const getDataLayerPageData = (pageType?: string) => {
  const type = isCategory(pageType) ? DL_PID_Type.category : DL_PID_Type.search;
  const pagePid = `GALLERY : ${type} : sort`;

  return { PID: pagePid } as DataLayerPage;
};

export const updateDataLayer = (response?: Omit<PLPData, 'rawResponse'>, pageType?: string): void => {
  if (!response?.meta) {
    return;
  }

  if (typeof window !== 'undefined' && window.mergeIntoDataLayer) {
    const dataLayerValues = getDataLayerValues(response, pageType) as Tracking;
    const dataLayerPage = getDataLayerPageData(pageType) as DataLayerPage;
    if (dataLayerValues) {
      const listingObject = {
        listing: dataLayerValues,
        page: dataLayerPage,
      };

      window.mergeIntoDataLayer(listingObject);
      publishAnalyticEvent(dataLayerValues);
    }
  }
};

export const getHeadHTMLadditionsClient = (response: PLPData, pageType?: string) => {
  const listing = getDataLayerValues(response, pageType) as Tracking;
  const page = getDataLayerPageData(pageType) as DataLayerPage;

  const listingDatalayer = `var listingData = ${JSON.stringify({ listing, page })};
  if(window.mergeIntoDataLayer)window.mergeIntoDataLayer(listingData)`;

  const headHTMLadditions = `
    ${listingDatalayer}
  `;
  return headHTMLadditions;
};
